import { fetchMetaBusinessExtension } from "./fetch-meta-business-extension";
import { installMetaBusinessExtension } from "./install-meta-business-extension";
import { uninstallMetaBusinessExtension } from "./uninstall-meta-business-extension";

export const facebookCommerceRepo = {
  getSettings: fetchMetaBusinessExtension,
  install: installMetaBusinessExtension,
  uninstall: uninstallMetaBusinessExtension,
};
